import React, { useContext } from "react";
import Grid from "@mui/material/Grid2";
import { Box, Button, Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import CalculateTwoToneIcon from "@mui/icons-material/CalculateTwoTone";
import WorkspacePremiumTwoToneIcon from "@mui/icons-material/WorkspacePremiumTwoTone";
import ModeStandbyTwoToneIcon from "@mui/icons-material/ModeStandbyTwoTone";
import DoubleArrowTwoToneIcon from "@mui/icons-material/DoubleArrowTwoTone";
import DateRangeTwoToneIcon from "@mui/icons-material/DateRangeTwoTone";
import CalendarMonthTwoToneIcon from "@mui/icons-material/CalendarMonthTwoTone";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../components/LanguageContext";

const Bullet = ({ children }) => (
    <Stack direction="row" spacing={1} alignItems="center">
        <CheckCircleRoundedIcon fontSize="small" color="success" />
        <Typography variant="body2">{children}</Typography>
    </Stack>
);

const CalculationsPage = () => {
    const navigate = useNavigate();
    const { translations } = useContext(LanguageContext);

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <Paper sx={{ p: 3 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                        <CalculateTwoToneIcon />
                        <Typography variant="h5" sx={{ fontWeight: 600 }}>
                            {translations.calculationsChoose || "Choose the calculation method"}
                        </Typography>
                    </Stack>
                </Paper>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Paper sx={{ p: 3, height: "100%" }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                        <ModeStandbyTwoToneIcon />
                        <Typography variant="h6" sx={{ fontWeight: 600, textAlign: "center" }}>
                            {translations.calculationsStandard || "KaproSCM standard method"}
                        </Typography>
                    </Stack>
                    <Divider sx={{ my: 2 }} />
                    <Stack spacing={1.5}>
                        <Bullet>{translations.calculationsStandardBullet1 || "Our own algorithm"}</Bullet>
                        <Bullet>{translations.calculationsStandardBullet2 || "Takes a little longer to calculate"}</Bullet>
                        <Bullet>{translations.calculationsStandardBullet3 || "Extremely accurate results"}</Bullet>
                    </Stack>
                    <Divider sx={{ my: 2 }} />
                    <Stack spacing={1.5}>
                        <Button
                            fullWidth
                            variant="contained"
                            endIcon={<DoubleArrowTwoToneIcon />}
                            startIcon={<CalendarMonthTwoToneIcon />}
                            onClick={() => navigate("/std/monthly/calculations")}
                        >
                            {translations.calculationsMonthly || "Monthly Calculations"}
                        </Button>
                        <Button
                            fullWidth
                            variant="contained"
                            endIcon={<DoubleArrowTwoToneIcon />}
                            startIcon={<DateRangeTwoToneIcon />}
                            onClick={() => navigate("/std/weekly/calculations")}
                        >
                            {translations.calculationsWeekly || "Weekly Calculations"}
                        </Button>
                    </Stack>
                </Paper>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Paper
                    sx={(t) => ({
                        p: 3,
                        height: "100%",
                        opacity: 0.55,
                        position: "relative",
                        background:
                            t.palette.mode === "dark"
                                ? "rgba(255,255,255,0.02)"
                                : "rgba(15,23,42,0.02)",
                    })}
                >
                    <Box sx={{ position: "absolute", top: 12, right: 12 }}>
                        <Chip
                            label={translations.disabledLabel || "Disabled"}
                            size="small"
                            color="default"
                        />
                    </Box>
                    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                        <WorkspacePremiumTwoToneIcon />
                        <Typography variant="h6" sx={{ fontWeight: 600, textAlign: "center" }}>
                            {translations.calculationsFp || "Forecast Pro® method"}
                        </Typography>
                    </Stack>
                    <Divider sx={{ my: 2 }} />
                    <Stack spacing={1.5}>
                        <Bullet>{translations.calculationsFpBullet1 || "We use precalculated data"}</Bullet>
                        <Bullet>{translations.calculationsFpBullet2 || "Lightning fast"}</Bullet>
                        <Bullet>{translations.calculationsFpBullet3 || "Extremely accurate results"}</Bullet>
                    </Stack>
                    <Divider sx={{ my: 2 }} />
                    <Stack spacing={1.5}>
                        <Button
                            fullWidth
                            variant="contained"
                            disabled
                            endIcon={<DoubleArrowTwoToneIcon />}
                            startIcon={<CalendarMonthTwoToneIcon />}
                        >
                            {translations.calculationsMonthly || "Monthly Calculations"}
                        </Button>
                        <Button
                            fullWidth
                            variant="contained"
                            disabled
                            endIcon={<DoubleArrowTwoToneIcon />}
                            startIcon={<DateRangeTwoToneIcon />}
                        >
                            {translations.calculationsWeekly || "Weekly Calculations"}
                        </Button>
                    </Stack>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CalculationsPage;
